import './App.css';
import Layout from './layouts/Layout';
import Introduction from './components/Introduction';
import Authentication from './components/Authentication';
import XML from './components/Xml';
import CDR from './components/Cdr';
import Emision from './components/Emision';
import Anulacion from './components/Anulacion';
import Factura from './components/Factura';
import NotaCredito from './components/NotaCredito';
import Boleta from './components/Boleta';
import Orden from './components/Orden';
import NotaDebito from './components/NotaDebito';
import ListComprobantes from './components/ListComprobantes';
import Resend from './components/Resend';
import Recover from './components/Recover';
import Detalle from './components/Detalle';
import Movimiento from './components/Movimiento';
import EmissionExamples from './components/EmissionExamples';
import SearchProduct from './components/SearchProduct';
import RecoverProduct from './components/RecoverProduct';
import DocExcelWord from './components/DocExcelWord';
import ConsultaApiRuc from './components/ConsultaApiRuc';
function App() {
  return (
    <Layout>
      {/* <ScrollToTopOnMount /> */}
      <Introduction />
      <Authentication />
      <Emision />
      <Detalle />
      <Movimiento />
      <DocExcelWord/>
      <Factura />
      
      <Boleta />
      <Anulacion />
      {/*<Orden />*/}
      {/*<NotaCredito />*/}
      {/*<NotaDebito />*/}
      
      {/*<EmissionExamples />*/}
      {/*<Movimiento />*/}
      
      {/*<ListComprobantes />*/}
      <XML />
      <CDR />
      <Resend />
      <Recover />
      <SearchProduct />
      <RecoverProduct />
      <ConsultaApiRuc/>
    </Layout>
  );
}

export default App;
